<script>
export default {
  props: {
    actions: {
      //
    },

    type: {
      type: String,
      required: false,
      default: null,
    },

    path: {
      type: String,
      required: false,
      default: null,
    },
  },

  inject: [
    'builder',
    'addAction',
    'addDecision',
    'removeAction',
    'removeDecision',
  ],

  computed: {
    active () {
      return this.builder.active;
    },

    last () {
      return this.actions[this.actions.length - 1] || {};
    },

    showAddAction () {
      return (this.actions && this.actions.length) || ! this.type;
    },

    lastFormated () {
      const {
        parent_id = null,
      } = this.last;

      return {
        parent_id,
        decision: this.type ? { decision: this.path, option: this.type } : null,
      };
    },

    addActionId () {
      return this.last.addActionId || 'add-action';
    },
  },

  methods: {
    hasMail (type) {
      return type === 'mail.send' || type === 'mail.notify_model';
    },

    showMail (job, actionable) {
      Bus.$emit('showActionMail', { job, actionable });
    },

    getTime (decision, humanized, index) {
      if (decision && decision.option == 1 || ! decision || index > 0) {
        return humanized;
      }

      if (humanized === 'Imediatamente') {
        return 'Executar após 1 dia (padrão)';
      }

      return `Executar após 1 dia (padrão) + ${humanized.split(' ').slice(-2).join(' ')}`;
    },
  },
};
</script>

<template>
  <div class="automation-builder-tree">
    <div
      :key="id"
      class="automation-builder-tree__wrapper"
      v-for="({ id, decision, id: actionId, parent_id, description, addDecisionId, addActionId, delayId, delay, job, hasDecisions, delayHumanized, actionable, value, option, children, type }, index) in actions"
    >
      <div
        :id="id"
        class="automation-builder-tree__action"
        @click.stop="addAction({ id, parent_id, decision, type, actionable: actionable || value, option, delay }, id, index > 0)"
      >
        <span class="automation-builder-tree__action-icon">
          <i :class="job.icon" />
        </span>

        <button
          class="automation-builder-tree__action-button"
          @click.stop.prevent="removeAction(id)"
        >
          <IconTrash color="#857A98" />
        </button>

        <button
          class="automation-builder-tree__action-button-eye"
          @click.stop.prevent="showMail(job, actionable)"
          v-if="hasMail(type)"
        >
          <IconEye color="#857A98" />
        </button>

        <div class="automation-builder-tree__action-body">
          <h2 class="automation-builder-tree__action-name">
            {{ __(job.name) }}
          </h2>

          <h3 class="automation-builder-tree__action-description">
            {{ description ? __(description) : '' }}
          </h3>
        </div>
      </div>

      <button
        v-if="hasDecisions"
        :id="addDecisionId"
        @click.stop.prevent="addDecision({ id, type }, addDecisionId)"
        class="automation-builder-tree__add-decision"
        :class="{ 'automation-builder-tree__add-decision--not-empty': children.length > 0 }"
      >
        +
      </button>

      <span
        :id="delayId"
        class="automation-builder-tree__delay"
      >
        <i class="fa fa-clock-o" /> {{ getTime(decision, delayHumanized, index) }}
      </span>

      <div
        :key="id"
        class="automation-builder-tree"
        v-for="({ id, yesId, noId, decision, items }) in children"
      >
        <div
          class="automation-builder-tree__title"
        >
          <button
            :id="yesId"
            :class="{ 'automation-builder-tree__decision--yes-empty': ! items['1'] }"
            class="automation-builder-tree__decision automation-builder-tree__decision--yes"
            @click.stop="addAction({ parent_id: actionId, decision: { decision: decision.path, option: '1' } }, yesId)"
          >
            <i class="fa fa-check" /> {{ __('Sim') }}
          </button>

          <div
            :id="id"
            class="automation-builder-tree__decision-content"
          >
            <h4
              class="automation-builder-tree__decision-content-title"
              v-html="__(decision.name) + '?'"
            />
            <button
              class="automation-builder-tree__decision-remove ml-1"
              @click.stop.prevent="removeDecision(id, actionId, [
                items['0'] && items['0'][0].id,
                items['1'] && items['1'][0].id,
              ])"
            >
              <IconTrash color="#F6F5F8" />
            </button>
          </div>

          <button
            :id="noId"
            :class="{ 'automation-builder-tree__decision--no-empty': ! items['0'] }"
            class="automation-builder-tree__decision automation-builder-tree__decision--no"
            @click.stop="addAction({ parent_id: actionId, decision: { decision: decision.path, option: '0' } }, noId)"
          >
            <i class="fa fa-times" /> {{ __('Não') }}
          </button>
        </div>

        <div
          class="automation-builder-tree__right"
        >
          <AutomationBuilderTree
            type="1"
            :key="yesId"
            :path="decision.path"
            :actions="items['1']"
          />

          <AutomationBuilderTree
            type="0"
            :key="noId"
            :path="decision.path"
            :actions="items['0']"
          />
        </div>
      </div>
    </div>

    <button
      :id="addActionId"
      v-if="showAddAction"
      @click.stop.prevent="addAction(lastFormated, addActionId, actions && actions.length > 0 || ! actions )"
      class="automation-builder-tree__add-action"
    >
      +
    </button>
  </div>
</template>

<style lang="scss">
  @import '../../../sass/variables';

  .automation-builder-tree {
    display: flex;
    min-width: 320px;
    width: max-content;
    position: relative;
    flex-direction: column;

    &__action {
      height: 140px;
      background-color: $white;
      padding: 30px 60px;
      border-radius: 15px;
      box-shadow: 0 5px 10px rgba(165, 131, 224, 0.1);
      z-index: 5;
      position: relative;

      &-body {
        width: 272px;
        font-weight: 500;
        letter-spacing: -.2px;
        display: inline-table;
        justify-content: space-between;
      }

      &-name {
        color: $gray-dark;
        font-size: 0.8125rem;
        line-height: 2em;
        margin-bottom: 8px;
      }

      &-description {
        color: $gray-light;
        font-size: 0.8125rem;
        line-height: 1.7em;
        font-style: italic;
      }

      &-icon {
        width: 30px;
        font-size: 20px;
        line-height: 1.5em;
        position: absolute;
        top: 30px;
        left: 30px;
      }

      &-button,
      &-button-eye {
        border: 0;
        background: none;
        position: absolute;
        top: 30px;
        right: 30px;
      }

      &-button-eye {
        top: 60px;
        padding-right: 4px;
      }
    }

    &__wrapper {
      display: flex;
      padding: 48px 64px;
    }

    &__delay {
      z-index: 2;
      padding: 4px;
      display: flex;
      line-height: 1;
      font-size: 11px;
      font-weight: 500;
      color: $gray-light;
      position: absolute;
      white-space: nowrap;
      align-items: center;
      word-break: keep-all;
      letter-spacing: -.17px;
      justify-content: center;
      background-color: $white-gray-2;

      i {
        margin-right: 4px;
      }
    }

    &__title {
      height: 140px;
      display: flex;
      margin-bottom: 40px;
      align-items: center;
      justify-content: center;
    }

    &__right {
      display: flex;
      flex-shrink: 0;
    }

    &__add-action,
    &__add-decision {
      border: 0;
      z-index: 2;
      width: 34px;
      height: 34px;
      line-height: 1;
      font-size: 28px;
      position: absolute;
      border-radius: 50%;
    }

    &__add-action {
      left: 243px;
      bottom: -32px;
      color: $gray-dark;
      background-color: $green;
    }

    &__add-decision {
      color: $white;
      margin-top: 53px;
      margin-left: 452px;
      background-color: $orange;

      &--not-empty {
        margin: 0;
        width: 46px;
        height: 46px;
        border: 6px solid $white-gray-2;
      }
    }

    &__decision {
      border: 0;
      z-index: 2;
      display: flex;
      font-size: 13px;
      font-weight: 500;
      line-height: 22px;
      position: absolute;
      align-items: center;
      background-color: $white-gray-2;

      &-content {
        color: $white-gray;
        background-color: $orange;
        position: relative;
        display: flex;
        align-items: center;
        padding: 15px 30px;
        border-radius: 15px;
        box-shadow: 0 5px 10px rgba(165, 131, 224, 0.1);
        z-index: 5;

        &-title {
          font-size: 0.8125rem;
          line-height: 2em;
          letter-spacing: -.2px;
          margin-bottom: 0;
        }

        &::after {
          top: 48px;
          right: 50%;
          content: '';
          width: 17px;
          height: 17px;
          z-index: 2;
          margin-right: -1px;
          position: absolute;
          border-radius: 50%;
          background-color: $orange;
          transform: translateX(50%);
          border: 3px solid $white-gray-2;
        }
      }

      &-remove {
        border: 0;
        color: $white;
        padding: 0 6px;
        background: none;

        &:hover {
          color: $white-gray;
        }
      }

      i {
        margin-right: 4px;
      }

      &--yes {
        color: $green;

        &-empty {
          margin-top: 160px;
          margin-left: -160px;
          // transform: translateY(95px) translateX(-92px);
        }
      }

      &--no {
        color: $pink;

        &-empty {
          margin-top: 160px;
          margin-left: 160px;
        }
      }
    }
  }
</style>
